import Http from 'axios'
import {API_URL, VERSION, VERSIONED_API_URL} from '../../config/config'

function initialState() {
    return{
        service_provider_types: [],
        service_provider_type_purposes: [],
        service_provider_purposes: [],
        service_provider_count: [],
        trekking_and_providers_count: {
            service_provider_count: 0,
            trekking_agency_count: 0,
            total_count: 0
        }
    }
}

const getters = {
    serviceProviderTypes: state => state.service_provider_types,
    serviceProviderTypePurposes: state => state.service_provider_type_purposes,
    serviceProviderPurposes: state => state.service_provider_purposes,
    serviceProviderCount: state => state.trekking_and_providers_count.service_provider_count,
    trekkingAgencyCount: state => state.trekking_and_providers_count.trekking_agency_count,
    totalCount: state => state.trekking_and_providers_count.total_count
}

const actions = {
      getAllServiceProviderTypes({commit, state, dispatch}) {
        return new Promise(((resolve, reject) => {
            Http.get(`${API_URL}${VERSION}/service-provider-type/all`).then((res) => {
                commit('setServiceProviderTypes', res.data.data)
                resolve(true)
            }).catch((err) => {
                reject(err)
            });
        }));
    },
    getAllServiceProviderTypePurpose({commit, state, dispatch},data) {
        return new Promise(((resolve, reject) => {
            Http.get(`${API_URL}${VERSION}/service-provider-type-purpose/`+data).then((res) => {
                commit('setServiceProviderTypePurposes', res.data.data)
                resolve(true)
            }).catch((err) => {
                reject(err)
            });
        }));
    },
    getAllTrekkingAndProvidersCount({commit}) {
        return new Promise((resolve, reject) => {
            Http.get(`${VERSIONED_API_URL}/service-providers-count`)
                .then((res) => {
                    commit('setTrekkingAndProvidersCount', res.data.data)
                    console.log('count', res.data.data)
                    resolve(res.data.data)
                })
                .catch((err) => {
                    console.error('Error fetching counts:', err)
                    reject(err)
                })
        })
    },
    getAllServiceProviderPurpose({commit, state, dispatch},data) {
        return new Promise(((resolve, reject) => {
            Http.get(`${API_URL}${VERSION}/service-provider-type-purpose/all`).then((res) => {
                commit('setServiceProviderPurposes', res.data.data)
                resolve(true)
            }).catch((err) => {
                reject(err)
            });
        }));
    }
}
const mutations = {
    setServiceProviderTypes(state, items) {
        state.service_provider_types = items
    },
    setServiceProviderTypePurposes(state, items) {
        state.service_provider_type_purposes = items
    } ,
    setTrekkingAndProvidersCount(state, items) {
        state.trekking_and_providers_count = items
    },
    setServiceProviderPurposes(state, items) {
        state.service_provider_purposes = items
    }
}

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}
